import welcomeBannerImg from '../../../../shared/assets/images/bonus-campaigns/deposit-bonus.png';

export const getPromoPath = (siteName, path = '') =>
  `/${siteName ? siteName + '/' : ''}promo${path ? '/' + path : ''}`;

export const getSitePath = (siteName, path = '') =>
  `/${siteName ? siteName + '/' : ''}${path}`;

export const getBonusCampaignLabels = (type = '') => {
  const labels = [];

  if (type.endsWith('_welcome')) {
    labels.push({ text: 'Welcome', isPrimary: true });
  } else if (type.endsWith('_retention')) {
    labels.push({ text: 'Loyalty', isPrimary: true });
  }

  if (type.startsWith('nodeposit_')) {
    labels.push({ text: 'No deposit' });
  } else if (type.startsWith('deposit_')) {
    labels.push({ text: 'Deposit' });
  }

  return labels;
};

export const getBonusCampaignBanner = (bonusCampaign, isOpened = false) =>
  (isOpened
    ? bonusCampaign.banners?.opened
    : bonusCampaign.banners?.small_card) || welcomeBannerImg;

export const getPassedBonusStatusText = (status) => {
  switch (status) {
    case 'success':
      return 'Completed';
    case 'failed':
      return 'Failed';
    case 'expired':
      return 'Expired';
    case 'cancelled':
    case 'cancelled_by_op':
      return 'Cancelled';
    default:
      return status;
  }
};

export const getBonusCampaignStepsText = (bonusCampaign, isUserLogin) => {
  if (!isUserLogin) return bonusCampaign.steps_logged_out_text;

  switch (bonusCampaign.bonus_state?.status) {
    case 'available':
      return bonusCampaign.steps_available_text;
    case 'pending':
      return bonusCampaign.steps_pending_text;
    case 'active':
      return bonusCampaign.steps_active_text;
    default:
      return '';
  }
};
